var render = function () {
  var _this$items;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [((_this$items = this.items) === null || _this$items === void 0 ? void 0 : _this$items.length) > 0 ? _c('div', {
    staticClass: "overflow-x-auto mt-4 border-gray-200 border-b border-t border-r border-l rounded-lg"
  }, [_c('Table', {
    attrs: {
      "headers": _vm.headers,
      "data": this.items,
      "withPagination": false,
      "isLoading": _vm.isLoading,
      "row-key": ['item_name', 'duration']
    },
    scopedSlots: _vm._u([{
      key: "duration",
      fn: function (_ref) {
        var value = _ref.value;
        return [_c('span', [_vm._v(" " + _vm._s(_vm.formatDuration(value)) + " ")])];
      }
    }], null, false, 729167203)
  })], 1) : _c('div', [!_vm.isLoading ? _c('div', {
    staticClass: "relative mt-4 overflow-x-auto my-2 mb-4 rounded-lg border-gray-200 border-b border-t border-r border-l"
  }, [_c('table', {
    staticClass: "min-w-full h-64 text-sm rounded-lg text-left"
  }, [_vm._m(0), _c('tbody', {
    staticClass: "bg-white"
  }, [_c('tr', [_c('td', {
    staticClass: "text-center py-8 text-gray-500",
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "flex-col items-center justify-center flex-nowrap flex",
    staticStyle: {
      "height": "574px"
    }
  }, [_c('svg', {
    staticClass: "w-14 h-14 text-gray-500 dark:text-white",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"
    }
  })]), _c('h4', {
    staticClass: "text-base text-gray-600 mb-0"
  }, [_vm._v("No Data")]), _c('p', {
    staticClass: "text-sm text-gray-500"
  }, [_vm._v("There are no data to display")])])])])])])]) : _vm._e()])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', {
    staticClass: "bg-gray-50 text-gray-700"
  }, [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("No")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("Content Title")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("Reading Duration")])])]);
}]

export { render, staticRenderFns }